<div *ngIf="ordersList && ordersList.length > 0" id="listCont">
    <h2>Pedidos mais recentes</h2>
    <div *ngFor="let order of ordersList" class="line" [routerLink]="['/app/pedidos']" [queryParams]="{id: order.idpedido}">
        <div class="l1">
            <span *ngIf="transformDate(order.data) !== 0">{{transformDate(order.data)}} </span>
            <span class="day" *ngIf="transformDate(order.data) === 0">hoje</span>
            <span class="day" *ngIf="transformDate(order.data) === 1">dia</span>
            <span class="day" *ngIf="transformDate(order.data) > 1">dias</span>
        </div>
        <div class="l2">
            N° {{order.idpedido}}
        </div>
        <div class="l3">
            {{order.total | currency: 'pt-br' : 'R$'}}
        </div>
        <div class="l4">
            <figure>
                <i *ngIf="order.entrega == 'S'" class="ic ic-moto"></i>
                <i *ngIf="order.entrega == 'N'" class="ic ic-build"></i>
            </figure>
        </div>
        <div class="l5">
            {{order.nome}}
        </div>
        <div class="l6">
            <div class="mesureCont">
                <div title="5%" *ngIf="order.idpedido_situacao === 9" class="mesurePorc" [style.background]="'rgb(255, 191, 45)'" [style.width.%]="'5'"></div>
                <div title="10%" *ngIf="order.idpedido_situacao === 1" class="mesurePorc" [style.background]="'rgb(255, 191, 45)'" [style.width.%]="'10'"></div>
                <div title="15%" *ngIf="order.idpedido_situacao === 2" class="mesurePorc" [style.background]="'rgb(255, 191, 45)'" [style.width.%]="'15'"></div>

                <div title="25%" *ngIf="order.idpedido_situacao === 3" class="mesurePorc" [style.background]="'rgb(38, 201, 252)'" [style.width.%]="'25'"></div>
                <div title="50%" *ngIf="order.idpedido_situacao === 4" class="mesurePorc" [style.background]="'rgb(38, 201, 252)'" [style.width.%]="'50'"></div>

                <div title="60%" *ngIf="order.idpedido_situacao === 6" class="mesurePorc" [style.background]="'rgb(0, 201, 151)'" [style.width.%]="'60'"></div>
                <div title="75%" *ngIf="order.idpedido_situacao === 5" class="mesurePorc" [style.background]="'rgb(0, 201, 151)'" [style.width.%]="'75'"></div>
                <div title="85%" *ngIf="order.idpedido_situacao === 7" class="mesurePorc" [style.background]="'rgb(0, 201, 151)'" [style.width.%]="'85'"></div>
                <div title="100%" *ngIf="order.idpedido_situacao === 8" class="mesurePorc" [style.background]="'rgb(0, 201, 151)'" [style.width.%]="'100'"></div>

                <div title="Cancelado" *ngIf="order.idpedido_situacao === 10" class="mesurePorc" [style.background]="'rgb(255, 115, 115)'" [style.width.%]="'100'"></div>
            </div>
            <span *ngIf="order.idpedido_situacao === 9">5%</span>
            <span *ngIf="order.idpedido_situacao === 1">10%</span>
            <span *ngIf="order.idpedido_situacao === 2">15%</span>
            <span *ngIf="order.idpedido_situacao === 3">25%</span>
            <span *ngIf="order.idpedido_situacao === 4">50%</span>
            <span *ngIf="order.idpedido_situacao === 6">60%</span>
            <span *ngIf="order.idpedido_situacao === 5">75%</span>
            <span *ngIf="order.idpedido_situacao === 7">85%</span>
            <span *ngIf="order.idpedido_situacao === 8">100%</span>
            <span class="cancelCase" *ngIf="order.idpedido_situacao === 10">Cancelado</span>
        </div>
        <div class="l7">

        </div>
    </div>
    <a [routerLink]="['/app/pedidos']" id="linkToOrder">
        Acompanhar todos os pedidos >
    </a>
</div>
